import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCommonApi } from '../../api';
import { PATHS } from '../../paths';
import { DashboardActionTile, DealerOnly } from '../common';
import { useAuth } from '../hooks';
import { AccidentAccidentInProgressDialog } from './AccidentAccidentInProgressDialog';

interface NewAccidentWidgetProps {
  onCreateNew?: () => void;
}

const NewAccidentWidget = ({ onCreateNew }: NewAccidentWidgetProps) => (
  <DashboardActionTile
    tone="primary"
    title="Nová nehoda"
    description="Založit nový případ k řešení"
    icon={<AddRoundedIcon fontSize="large" />}
    onClick={onCreateNew}
  />
);

const NewAccidentWidgetConnectedContent = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [openNewAccidentDialog, setOpenNewAccidentDialog] = useState(false);

  const { mutate: removeAccident } = useMutation(useCommonApi().removeAccident());

  const handleCreateNewAccident = () => {
    if (Boolean(user?.accidentInProgress)) {
      setOpenNewAccidentDialog(true);
    } else {
      navigate(PATHS.NEW_ACCIDENT());
    }
  };

  const handleRemoveAccidentAndCreateNew = () => {
    if (user?.accidentInProgress) removeAccident({ accidentId: user?.accidentInProgress?.toString() });
    navigate(PATHS.NEW_ACCIDENT());
  };

  return (
    <>
      <NewAccidentWidget onCreateNew={handleCreateNewAccident} />
      <AccidentAccidentInProgressDialog
        open={openNewAccidentDialog}
        onClose={() => setOpenNewAccidentDialog(false)}
        onAccept={() => navigate(PATHS.NEW_ACCIDENT(user?.accidentInProgress?.toString()))}
        onDeny={handleRemoveAccidentAndCreateNew}
      />
    </>
  );
};

export const NewAccidentWidgetConnected = () => (
  <DealerOnly>
    <NewAccidentWidgetConnectedContent />
  </DealerOnly>
);
